//Core
import React, { useReducer } from "react"

//Action
import formActions from "../actions/formActions"

//Itils
import axios from "axios"

//Helpers
import {
  validatePhoneNumber,
  transformPhoneAfterMask,
} from "../helpers/validation"

const {
  START_FETCH,
  FINISH_FETCH,
  FETCH_SUCCESS,
  FETCH_FAIL,
  CHANGE_NAME,
  VALID_NAME,
  CHANGE_PHONE,
  VALID_PHONE,
  CHECKED_NAME,
  CHECKED_PHONE,
  CHANGE_INN,
  CHECKED_INN,
  VALID_INN,
} = formActions

const getUrlParams = () => {
  if (typeof window !== `undefined`) {
    return window.location.search
      .substr(1)
      .split("&")
      .map(el => el.split("="))
      .reduce((acc, arr) => ((acc[arr[0]] = arr[1]), acc), {})
  } else return {}
}
const checkUserPhone = () => {
  const { phone } = getUrlParams()
  console.log("phone", phone)
  console.log("param")

  return phone
}

const initialState = {
  fetch: false,
  success: false,
  fail: false,
  phone: {
    valid: false,
    value: checkUserPhone(),
    checked: false,
    haveInitial: !!checkUserPhone(),
  },
}

const reducer = (state, action) => {
  switch (action.type) {
    case START_FETCH:
      return { ...state, fetch: true }
    case FINISH_FETCH:
      return { ...state, ...initialState }
    case FETCH_SUCCESS:
      return { ...state, fetch: false, success: true }
    case FETCH_FAIL:
      return { ...state, fetch: false, fail: true }

    case CHECKED_PHONE:
      return { ...state, phone: { ...state.phone, checked: true } }

    case CHANGE_PHONE:
      return { ...state, phone: { ...state.phone, value: action.payload } }
    case VALID_PHONE:
      return {
        ...state,
        phone: { ...state.phone, valid: action.payload },
      }

    default:
      return state
  }
}

const useForm = link => {
  const [state, dispatch] = useReducer(reducer, initialState)

  //UI
  const startFetch = () => dispatch({ type: START_FETCH })
  const finishFetch = () => dispatch({ type: FINISH_FETCH })
  const fetchSuccess = () => dispatch({ type: FETCH_SUCCESS })
  const fetchFail = () => dispatch({ type: FETCH_FAIL })

  //Phone
  const checkedPhone = () => dispatch({ type: CHECKED_PHONE })

  const validPhone = isValidPhone =>
    dispatch({ type: VALID_PHONE, payload: isValidPhone })
  const changePhone = phone => {
    dispatch({ type: CHANGE_PHONE, payload: phone })
    const normalPhone = transformPhoneAfterMask(phone)

    const isValidPhone = validatePhoneNumber(normalPhone)
    validPhone(isValidPhone)
  }

  //Inn

  const onClick = async () => {
    try {
      const { phone } = state

      ///Transform form after mask
      const normalPhone = transformPhoneAfterMask(phone.value)

      //Validate fileds
      const isValidPhone = validatePhoneNumber(normalPhone)

      checkedPhone()

      //Set fields
      validPhone(isValidPhone)

      if (isValidPhone) {
        startFetch()
        try {
          console.table({ phone })

          const res = await axios.post(link, {
            phone: normalPhone,
          })

          console.log(res)
          res.status === 201 || res.status == 200 ? fetchSuccess() : fetchFail()
        } catch (error) {
          console.log("error", error)
          fetchFail()
        } finally {
          finishFetch()
        }
      }
    } catch (error) {
      console.log("err", error)
    }
  }

  return {
    state,

    checkedPhone,
    changePhone,
    onClick,
  }
}

export default useForm
